// extracted by mini-css-extract-plugin
module.exports = {"contentModul":"elsnostresjocs_contentModul__hyOKP","innerWrapper":"elsnostresjocs_innerWrapper__Vhj_1","info":"elsnostresjocs_info__Rrpi0","icona":"elsnostresjocs_icona__xHaP6"};